import * as types from '../actionTypes/perfiosCompleteActionTypes'
import axios from 'axios'
import { API_ENDPOINTS, AUTH_KEY } from "../../constants/constants"
import { getTransactionIdFromURL, saveKeyToLocalStorage } from '../../constants/utils'
import { getValueFromLocalStorage, replaceValueFromLocalStorage } from '../../constants/utils'

export const perfiosCompleteStart = () => ({
    type: types.PERFIOS_COMPLETE_START,
})

export const perfiosCompleteSuccess = (data:object) => ({
    type: types.PERFIOS_COMPLETE_SUCCESS,
    payload: data
})

export const perfiosCompleteError = () => ({
    type: types.PERFIOS_COMPLETE_ERROR,
})
export const perfiosCompleteReset = () => ({
    type: types.PERFIOS_COMPLETE_RESET
    
})
  
export const perfiosCompleteApi=()=>{
    return (dispatch) => {
        dispatch (perfiosCompleteStart())
        let txnId = getTransactionIdFromURL();
        let authKey = getValueFromLocalStorage(AUTH_KEY(txnId))
        axios({
            method: "post",
            url: API_ENDPOINTS.PERFIOS_COMPLETE,
            headers: {
            "Content-Type": "application/json",
            "Accept": "application/json",
            "Authorization": `Bearer ${authKey}`,
            "x-custom-txn-id": txnId,
            },
        })
        .then(function (response) {
            if(response){
                let token = response.headers.authorization
                if(token) saveKeyToLocalStorage(AUTH_KEY(txnId), token)
                const data = response.data
                dispatch(perfiosCompleteSuccess(data))
            }
        })
        .catch(function (response) {
            dispatch(perfiosCompleteError())
        });
    }
}